import { from as fromPromise, of, Observable, from } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppService } from '../shared/app.service';
import { IPagerModel } from '../shared/pagermodel';
import { MenuService } from '../shared/menu.service';
import { state2 } from '../shared/state';
import { IZittingDb, IDocumentDb, defaultCacheTime } from '../shared/offline/cobradb';
import { map } from 'rxjs/operators';

export interface IKalenderData extends IZittingDb {
  IsMonthChanged?: boolean;
  identifier?: string;
}

export interface IDocument extends IDocumentDb {
  // Id: number;
  // DatumUpdate: Date | string;
  // Omschrijving: string;
  // AgendapuntId?: number;
  // ZittingId?: number;
  AtHomeColorClass: string;
  detail?: IDetailDocument;
  identifier?: string;
  IsNew: boolean;
}

export const enum DateRange {
  Period0 = 0,
  Period1 = 1,
  Period2 = 2,
  Period3 = 3,
  Period4 = 4,
  Period5 = 5
}

export interface IDocumentPeriod {
  Name: string;
  DateRange: DateRange;
}

export const DocumentPeriods: IDocumentPeriod[] = [
  { Name: 'Vandaag', DateRange: DateRange.Period0 },
  { Name: 'Gisteren', DateRange: DateRange.Period1 },
  { Name: 'Eergisteren', DateRange: DateRange.Period2 },
  // {Name:'Dag-3',DateRange:DateRange.Period3},
  { Name: '-3 tot -7 dagen', DateRange: DateRange.Period4 },
  // {Name:'Laatste maand',DateRange:DateRange.Period5}
];

export interface IDetailDocument {
  PuntId?: number;
  ZittingId: number;
  SoortZitting: string;
  DatumZitting: string;
  Titel: string;
}
export const noDocument: Partial<IDocument> = {
  Id: -1
};

@Injectable()
export class DashboardService {

  constructor(private appService: AppService,
    private menuService: MenuService, private http: HttpClient) { }

  public getKalender(page: number, force: boolean = false) {
    const url = this.appService.getUrl(`api/zitting/getzittingen`); // ?vanIncl=2012-01-01&totExcl=2013-01-01
    return state2.getValueOrDefault<IKalenderData[]>('kalenderdata', this.http.post<IKalenderData[]>(url, {}));
  }

  public getDetailDocument(document: IDocument) {
    if (document.Id === noDocument.Id) { return of(null as IDetailDocument); }
    let url: string;
    if (document.AgendapuntId) {
      url = this.appService.getUrl(`api/DocumentAgendapunt/getdetail?id=${document.Id}`);
    } else {
      url = this.appService.getUrl(`api/DocumentZitting/getdetail?id=${document.Id}`);
    }
    return this.http.post<IDetailDocument>(url, {});
  }

  public getRecenteDocumentenZitting(dateRange: DateRange) {
    const url = this.appService.getUrl(`api/DocumentZitting/getrecentedocumenten?dateRange=${dateRange}`);
    return state2.getSubValueOrDefault('recentedocumenten', dateRange, this.http.post<IDocument[]>(url, {}));
  }

  private getDocumentsWithExtension(documents: IDocument[]) {
    documents.forEach(d => d.Titel = this.appService.getTitelWithExtension(d.Titel, d.Verwijzing));
    return documents;
  }

  public getAllRecenteDocumenten(dateRange: DateRange, force: boolean = false) {
    const subkey = `${dateRange}`;
    const url = this.appService.getUrl(`api/RecentDocument/getrecentedocumenten?dateRange=${dateRange}`);
    const getRecenteDocumentenWithExt$ = this.http.post<IDocument[]>(url, {}).pipe(
      map(documents => this.getDocumentsWithExtension(documents))
    );
    return state2.getSubValueOrDefault('recentedocumenten', dateRange, getRecenteDocumentenWithExt$);
  }
}

